import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// ID-059: active product formats from the central format registry
export function useFormats() {
  const [formats, setFormats] = useState([]);
  useEffect(() => {
    api.get("/product-formats").then(({ data }) => setFormats(data)).catch(() => setFormats([]));
  }, []);
  return formats;
}
